module.exports = __webpack_public_path__ + "static/media/keycompounding_homepage.dfe987ff.png";